// extracted by mini-css-extract-plugin
export default {"textfield":"input_textfield","textarea":"input_textarea"};